(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-rabatt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.crb-section');
    if (!sections.length) return;

    function fmtEUR(cents) {
      return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }
    function fmtEURVal(eur) {
      return eur.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }

    function pickTier(totalEUR, tiers) {
      var active = null, next = null;
      var sorted = tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
      for (var i = 0; i < sorted.length; i++) {
        if (totalEUR >= sorted[i].threshold) active = sorted[i];
        else { next = sorted[i]; break; }
      }
      return { active: active, next: next, sorted: sorted };
    }

    function render(section, cart) {
      var tiers;
      try { tiers = JSON.parse(section.getAttribute('data-crb-tiers')); }
      catch (e) { tiers = []; }
      var shipThreshold = parseFloat(section.getAttribute('data-crb-ship-threshold')) || 0;
      var shipRegular = parseFloat(section.getAttribute('data-crb-ship-regular')) || 0;

      var totalCents = cart && typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : (cart && typeof cart.total_price === 'number' ? cart.total_price : 0);
      var totalEUR = totalCents / 100;

      // Versand
      var shipBox = section.querySelector('[data-crb-ship]');
      var shipText = section.querySelector('[data-crb-ship-text]');
      var shipBar = section.querySelector('[data-crb-ship-progress]');
      if (totalEUR >= shipThreshold && shipThreshold > 0) {
        shipBox.classList.add('is-reached');
        shipText.innerHTML = '🎉 <strong>Versandkostenfrei gesichert!</strong> Sie sparen heute die kompletten Versandkosten.';
        shipBar.style.width = '100%';
      } else {
        shipBox.classList.remove('is-reached');
        var need = Math.max(0, shipThreshold - totalEUR);
        var prog = shipThreshold > 0 ? Math.min(100, (totalEUR / shipThreshold) * 100) : 0;
        shipText.innerHTML = 'Nur heute (WM-Aktion): Versandkostenfrei ab <strong>' + shipThreshold + ' €</strong> ' +
          '<span class="crb-ship-strike">statt ' + shipRegular + ' €</span><br>' +
          'Noch <strong>' + fmtEURVal(need) + '</strong> bis zum kostenfreien Versand.';
        shipBar.style.width = prog + '%';
      }

      // Rabattstufen
      var tierBox = section.querySelector('[data-crb-tier]');
      var picked = pickTier(totalEUR, tiers);
      var html = '';
      if (totalCents === 0) {
        var first = picked.sorted[0];
        html = '<div class="crb-tier-empty">Legen Sie Artikel in den Warenkorb und sichern Sie sich ab <strong>' +
          first.threshold + ' €</strong> bereits <strong>−' + first.percent + '%</strong> Rabatt.</div>';
      } else if (picked.active) {
        var savingCents = Math.round(totalCents * (picked.active.percent / 100));
        var nextHtml = '';
        if (picked.next) {
          var needEUR = picked.next.threshold - totalEUR;
          nextHtml = '<div class="crb-tier-next">Noch <strong>' + fmtEURVal(needEUR) +
            '</strong> bis <strong>−' + picked.next.percent + '%</strong></div>';
        } else {
          nextHtml = '<div class="crb-tier-next">🏆 Maximale Stufe erreicht!</div>';
        }
        html = '<div class="crb-tier-row">' +
          '<div class="crb-tier-active"><span>✨</span>' +
          '<span>Sie sparen <strong>' + fmtEUR(savingCents) + '</strong> (−' + picked.active.percent + '%)</span>' +
          '</div>' + nextHtml + '</div>';
      } else {
        var firstT = picked.sorted[0];
        var needFirst = firstT.threshold - totalEUR;
        html = '<div class="crb-tier-empty">Noch <strong>' + fmtEURVal(needFirst) +
          '</strong> bis zur ersten Rabattstufe (<strong>−' + firstT.percent + '%</strong> ab ' + firstT.threshold + ' €).</div>';
      }
      tierBox.innerHTML = html;

      // Treppe
      var stairsBox = section.querySelector('[data-crb-stairs]');
      var stairsHtml = '';
      picked.sorted.forEach(function (t) {
        var isActive = picked.active && picked.active.threshold === t.threshold;
        stairsHtml += '<div class="crb-step' + (isActive ? ' is-active' : '') + '">' +
          '<strong>−' + t.percent + '%</strong>ab ' + t.threshold + ' €</div>';
      });
      stairsBox.innerHTML = stairsHtml;
    }

    function fetchAndRender() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { sections.forEach(function (s) { render(s, cart); }); })
        .catch(function () {});
    }

    fetchAndRender();

    ['cart:updated', 'cart:refresh', 'cart:change', 'cart.requestComplete'].forEach(function (ev) {
      document.addEventListener(ev, fetchAndRender);
    });

    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0];
        var p = origFetch.apply(this, arguments);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(fetchAndRender, 150); });
        }
        return p;
      };
    }

    sections.forEach(function (section) {
      var el = section.querySelector('[data-crb-countdown]');
      if (!el) return;
      function tick() {
        var now = new Date();
        var end = new Date();
        end.setHours(23, 59, 59, 999);
        var diff = Math.max(0, end - now);
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["her-mit-rabattstaflle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.hcs-section[data-hcs-cd]');
  if(!roots.length) return;
  function pad(n){ return String(n).padStart(2,'0'); }
  roots.forEach(function(root){
    var els = root.querySelectorAll('[data-hcs-countdown]');
    if(!els.length) return;
    var mode = root.getAttribute('data-hcs-mode') || 'midnight';
    var endDateStr = root.getAttribute('data-hcs-end-date') || '';
    var endTimeStr = root.getAttribute('data-hcs-end-time') || '23:59:59';
    var endedLabel = root.getAttribute('data-hcs-ended') || '00:00:00';
    function computeEnd(){
      if(mode === 'fixed' && endDateStr){
        var t = endTimeStr && endTimeStr.length ? endTimeStr : '23:59:59';
        if(t.length === 5) t += ':00';
        var d = new Date(endDateStr + 'T' + t);
        if(!isNaN(d.getTime())) return d;
      }
      var now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    }
    var urgencyEls = root.querySelectorAll('[data-hcs-urgency]');
    function tick(){
      var end = computeEnd();
      var diff = end - new Date();
      if(diff <= 0){
        els.forEach(function(el){ el.textContent = endedLabel; });
        urgencyEls.forEach(function(el){ el.textContent = endedLabel; });
        return;
      }
      var days = Math.floor(diff/86400000);
      var h = Math.floor((diff%86400000)/3600000);
      var m = Math.floor((diff%3600000)/60000);
      var s = Math.floor((diff%60000)/1000);
      var txt = (days > 0 ? days + 'T ' : '') + pad(h)+':'+pad(m)+':'+pad(s);
      els.forEach(function(el){ el.textContent = txt; });
      if(mode === 'fixed'){
        var uTxt;
        if(days >= 1){ uTxt = 'Nur noch ' + days + (days === 1 ? ' Tag' : ' Tage'); }
        else if(h >= 1){ uTxt = 'Nur noch ' + h + (h === 1 ? ' Stunde' : ' Stunden'); }
        else { uTxt = 'Nur noch ' + Math.max(1,m) + (m === 1 ? ' Minute' : ' Minuten'); }
        urgencyEls.forEach(function(el){ el.textContent = uTxt; });
      }
    }
    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.hcs-section[data-hcs-cd]');
  if(!roots.length) return;
  function pad(n){ return String(n).padStart(2,'0'); }
  roots.forEach(function(root){
    var els = root.querySelectorAll('[data-hcs-countdown]');
    if(!els.length) return;
    var mode = root.getAttribute('data-hcs-mode') || 'midnight';
    var endDateStr = root.getAttribute('data-hcs-end-date') || '';
    var endTimeStr = root.getAttribute('data-hcs-end-time') || '23:59:59';
    var endedLabel = root.getAttribute('data-hcs-ended') || '00:00:00';
    function computeEnd(){
      if(mode === 'fixed' && endDateStr){
        var t = endTimeStr && endTimeStr.length ? endTimeStr : '23:59:59';
        if(t.length === 5) t += ':00';
        var d = new Date(endDateStr + 'T' + t);
        if(!isNaN(d.getTime())) return d;
      }
      var now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    }
    var urgencyEls = root.querySelectorAll('[data-hcs-urgency]');
    function tick(){
      var end = computeEnd();
      var diff = end - new Date();
      if(diff <= 0){
        els.forEach(function(el){ el.textContent = endedLabel; });
        urgencyEls.forEach(function(el){ el.textContent = endedLabel; });
        return;
      }
      var days = Math.floor(diff/86400000);
      var h = Math.floor((diff%86400000)/3600000);
      var m = Math.floor((diff%3600000)/60000);
      var s = Math.floor((diff%60000)/1000);
      var txt = (days > 0 ? days + 'T ' : '') + pad(h)+':'+pad(m)+':'+pad(s);
      els.forEach(function(el){ el.textContent = txt; });
      if(mode === 'fixed'){
        var uTxt;
        if(days >= 1){ uTxt = 'Nur noch ' + days + (days === 1 ? ' Tag' : ' Tage'); }
        else if(h >= 1){ uTxt = 'Nur noch ' + h + (h === 1 ? ' Stunde' : ' Stunden'); }
        else { uTxt = 'Nur noch ' + Math.max(1,m) + (m === 1 ? ' Minute' : ' Minuten'); }
        urgencyEls.forEach(function(el){ el.textContent = uTxt; });
      }
    }
    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staffel-rabatt-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-srp-countdown]').forEach(function (el) {
      function tick() {
        var now = new Date();
        var end = new Date();
        end.setHours(23, 59, 59, 999);
        var diff = Math.max(0, end - now);
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staffelrabatt-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.src-section');
    if (!sections.length) return;

    function formatEUR(cents) {
      return (cents / 100).toLocaleString('de-DE', {
        style: 'currency', currency: 'EUR'
      });
    }

    function pickTier(totalEUR, tiers) {
      var active = null;
      var next = null;
      var sorted = tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
      for (var i = 0; i < sorted.length; i++) {
        if (totalEUR >= sorted[i].threshold) active = sorted[i];
        else { next = sorted[i]; break; }
      }
      return { active: active, next: next, sorted: sorted };
    }

    function render(section, cart) {
      var tiers;
      try { tiers = JSON.parse(section.getAttribute('data-src-tiers')); }
      catch (e) { tiers = []; }
      if (!tiers.length) return;

      var totalCents = cart && typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : (cart && typeof cart.total_price === 'number' ? cart.total_price : 0);
      var totalEUR = totalCents / 100;

      var elActive = section.querySelector('[data-src-active]');
      var elInactive = section.querySelector('[data-src-inactive]');
      var elEmpty = section.querySelector('[data-src-empty]');

      if (!totalCents) {
        elActive.hidden = true;
        elInactive.hidden = true;
        elEmpty.hidden = false;
        return;
      }
      elEmpty.hidden = true;

      var picked = pickTier(totalEUR, tiers);

      if (picked.active) {
        elInactive.hidden = true;
        elActive.hidden = false;
        var pct = picked.active.percent;
        var savingCents = Math.round(totalCents * (pct / 100));
        var finalCents = totalCents - savingCents;

        section.querySelector('[data-src-original]').textContent = formatEUR(totalCents);
        section.querySelector('[data-src-final]').textContent = formatEUR(finalCents);
        section.querySelector('[data-src-saving-amount]').textContent = formatEUR(savingCents);
        section.querySelector('[data-src-saving-pct]').textContent = '(−' + pct + '%)';

        var nextBox = section.querySelector('[data-src-next]');
        if (picked.next) {
          var needEUR = picked.next.threshold - totalEUR;
          var prevThreshold = picked.active.threshold;
          var span = picked.next.threshold - prevThreshold;
          var progressPct = span > 0
            ? Math.max(0, Math.min(100, ((totalEUR - prevThreshold) / span) * 100))
            : 100;
          section.querySelector('[data-src-next-amount]').textContent =
            needEUR.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
          section.querySelector('[data-src-next-pct]').textContent = '−' + picked.next.percent + '%';
          section.querySelector('[data-src-progress]').style.width = progressPct + '%';
          nextBox.hidden = false;
        } else {
          nextBox.hidden = true;
        }
      } else {
        elActive.hidden = true;
        elInactive.hidden = false;
        var first = picked.sorted[0];
        var needFirstEUR = first.threshold - totalEUR;
        var progressFirst = Math.max(0, Math.min(100, (totalEUR / first.threshold) * 100));
        section.querySelector('[data-src-first-threshold]').textContent =
          first.threshold.toLocaleString('de-DE') + ' €';
        section.querySelector('[data-src-first-pct]').textContent = '−' + first.percent + '%';
        section.querySelector('[data-src-need]').textContent =
          needFirstEUR.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
        section.querySelector('[data-src-progress-inactive]').style.width = progressFirst + '%';
      }
    }

    function fetchAndRender() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          sections.forEach(function (s) { render(s, cart); });
        })
        .catch(function () {});
    }

    // Initial
    fetchAndRender();

    // Reagiert auf Cart-Änderungen (Standard-Events vieler Themes)
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart.requestComplete'].forEach(function (ev) {
      document.addEventListener(ev, fetchAndRender);
    });

    // Fängt AJAX-Cart-Mutationen ab
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0];
        var p = origFetch.apply(this, arguments);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(fetchAndRender, 150); });
        }
        return p;
      };
    }

    // Countdown
    sections.forEach(function (section) {
      var el = section.querySelector('[data-src-countdown]');
      if (!el) return;
      function tick() {
        var now = new Date();
        var end = new Date();
        end.setHours(23, 59, 59, 999);
        var diff = Math.max(0, end - now);
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
